import React, { useCallback, useState } from 'react';

import { SMTP_SERVER_FIELDS } from '../../common/fields';
import * as actions from '../../containers/General/generalActions';
import TextInput from '../Controls/TextInput/TextInput';
import Account from '../Controls/Account/Account';
import SwitchField from '../Controls/SwitchField/SwitchField';
import LabeledButton from '../Controls/LabeledButton/LabeledButton';
import TestSMTPSendMailPopup from './TestSMTPSendMailPopup';

import styles from './SMTPServer.module.css';

const { SMTP_SERVER_URL, SMTP_FROM_ADDRESS, SMTP_ACCOUNT, SMTP_ENABLED } = SMTP_SERVER_FIELDS;

const SMTPServer = ({ fields, dispatch, isDirty }) => {
    const [openTestModal, setOpenTestModal] = useState(false);

    const smtpEnabled = fields[SMTP_ENABLED.ID];
    const serverUrl = fields[SMTP_SERVER_URL.ID];
    const fromAddress = fields[SMTP_FROM_ADDRESS.ID];
    const smtpAccount = fields[SMTP_ACCOUNT.ID];

    const toggleTestPopup = useCallback(() => {
        setOpenTestModal((isOpen) => !isOpen);
    }, [setOpenTestModal]);

    const dispatchUpdate = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.UPDATE_SMTP_SERVER,
                payload: { fieldId, value }
            });
        },
        [dispatch]
    );

    const isSMTPEnabled = smtpEnabled ? smtpEnabled.value : false;
    const isSMTPUrlSet = serverUrl ? !!serverUrl.value : false;

    return (
        <>
            {smtpEnabled && <SwitchField field={smtpEnabled} changed={dispatchUpdate} />}
            {serverUrl && (
                <TextInput
                    disabled={!isSMTPEnabled}
                    field={serverUrl}
                    placeholder="smtp.office365.com:587"
                    changed={dispatchUpdate}
                />
            )}
            {fromAddress && (
                <TextInput
                    disabled={!isSMTPEnabled}
                    field={fromAddress}
                    placeholder="no-reply@acme.com"
                    changed={dispatchUpdate}
                />
            )}
            {smtpAccount && <Account disabled={!isSMTPEnabled} field={smtpAccount} changed={dispatchUpdate} />}
            <div className={styles.testSection}>
                <LabeledButton
                    onClick={toggleTestPopup}
                    disabled={isDirty || !isSMTPEnabled || !isSMTPUrlSet}
                    label={'Send Test Mail'}
                    buttonText={'Test'}
                />
            </div>
            {openTestModal && <TestSMTPSendMailPopup onCancel={toggleTestPopup} />}
        </>
    );
};

export default React.memo(SMTPServer);
